import { WorkflowPreset } from '../types';

export const patientPreset: WorkflowPreset = {
  id: 'patient',
  label: 'Patient Viewer',
  panels: {
    rightPanelClosed: true,
  },
  header: {
    showPatientInfo: true,
    showReturnButton: false,
  },
  customizations: {
    'studyBrowser.hideFilterBar': false,
  },
  dataFilters: {
    skipSeriesFilter: true,
    skipImageSetFilter: true,
    skipDatastoreFilter: true,
    allowMrnWidening: true,
  },
  // Open CT studies in the Bone window preset (WW=2500, WL=480) by default.
  defaultVoi: { windowWidth: 2500, windowCenter: 480 },
};
